import LegalLayout from '@/components/LegalLayout';

/*
 * ============================================================================
 * ENTWURF — VOR PRODUKTIVGANG JURISTISCH PRÜFEN LASSEN.
 * ============================================================================
 * App-spezifische Datenschutzerklärung. Bewusst NICHT von always-on-stock.de
 * kopiert: die App verarbeitet andere/mehr Daten (Accounts, Auth-Session,
 * aus weclapp synchronisierte Mandantendaten, Server-Logs).
 *
 * Vor dem Livegang prüfen/ergänzen:
 *  - Konkrete Auftragsverarbeiter + abgeschlossene AVV (Hetzner; Mailer falls genutzt).
 *  - Tatsächliche Speicher-/Löschfristen je Datenkategorie.
 *  - Rolle als Auftragsverarbeiter der Mandanten: passt der AVV-Verweis?
 *  - Cookie-Bestand final gegen den echten Code abgleichen.
 * ============================================================================
 */
export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung" updated="Juli 2026">
      <p>
        Diese Datenschutzerklärung gilt für die Nutzung der Web-Anwendung
        „always·on·stock“ (nachfolgend „App“). Sie informiert über die Verarbeitung
        personenbezogener Daten im Rahmen des Betriebs der App. Für die öffentliche
        Website <a href="https://always-on-stock.de" target="_blank" rel="noopener noreferrer">always-on-stock.de</a>{' '}
        gilt die dort hinterlegte Datenschutzerklärung.
      </p>

      <h2>1. Verantwortlicher</h2>
      <address>
        blitzblank GmbH<br />
        Giesenkamp 110<br />
        59348 Lüdinghausen<br />
        Deutschland<br />
        E-Mail: <a href="mailto:hallo@always-on-stock.de">hallo@always-on-stock.de</a>
      </address>

      <h2>2. Zuständige Aufsichtsbehörde</h2>
      <p>
        Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW),
        Kavalleriestraße 2-4, 40213 Düsseldorf,{' '}
        <a href="https://www.ldi.nrw.de" target="_blank" rel="noopener noreferrer">www.ldi.nrw.de</a>.
      </p>

      <h2>3. Verarbeitungen bei Nutzung der App</h2>

      <h3>a) Registrierung, Anmeldung und Kontoverwaltung</h3>
      <p>
        Für die Bereitstellung eines Nutzerkontos verarbeiten wir die von dir angegebenen
        Bestandsdaten (u. a. E-Mail-Adresse, Passwort in gehashter Form, Zuordnung zu einem
        Mandanten). Zweck ist die Einrichtung, Authentifizierung und Verwaltung deines Zugangs.
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung bzw. vorvertragliche
        Maßnahmen).
      </p>

      <h3>b) Authentifizierung und Sitzung (technisch notwendige Cookies)</h3>
      <p>
        Zur Anmeldung und zum Aufrechterhalten deiner Sitzung setzen wir ausschließlich technisch
        notwendige Cookies bzw. vergleichbare Speichermechanismen. Diese speichern keine Daten zu
        Werbezwecken und dienen nicht dem Tracking. Rechtsgrundlage ist § 25 Abs. 2 Nr. 2 TDDDG
        (unbedingt erforderlich) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem
        sicheren, funktionsfähigen Login).
      </p>

      <h3>c) Bereitstellung der Anwendung und Verarbeitung von Bestands- und Warenwirtschaftsdaten</h3>
      <p>
        Im laufenden Betrieb verarbeiten wir die in der App genutzten Bestands-, Artikel-,
        Lieferanten- und Bestelldaten deines Mandanten, um die vertraglich geschuldeten Funktionen
        (Bestandsüberwachung, Risiko- und Nachbestellanalysen, Auswertungen) zu erbringen.
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO. Soweit diese Daten personenbezogene Angaben
        enthalten (z. B. Ansprechpartner bei Lieferanten), siehe Ziffer 6.
      </p>

      <h3>d) Anbindung an weclapp</h3>
      <p>
        Die App synchronisiert auf deine Veranlassung Daten aus dem von dir verbundenen
        weclapp-Konto über die weclapp-Schnittstelle (API), etwa Artikel-, Bestands-, Lieferanten-
        und Auftragsdaten. Zweck ist die Bereitstellung der App-Funktionen. Rechtsgrundlage ist
        Art. 6 Abs. 1 lit. b DSGVO. Die Verbindung erfolgt verschlüsselt.
      </p>

      <h3>e) Server-Logfiles und Fehlerprotokolle</h3>
      <p>
        Beim Zugriff auf die App werden technisch erforderliche Protokolldaten verarbeitet
        (u. a. IP-Adresse, Zeitpunkt, aufgerufene Ressource, Statuscode, User-Agent). Zweck ist der
        sichere und stabile Betrieb sowie die Abwehr von Missbrauch. Rechtsgrundlage ist
        Art. 6 Abs. 1 lit. f DSGVO. Die Daten werden nach kurzer Zeit gelöscht bzw. anonymisiert.
      </p>

      <h2>4. Hosting</h2>
      <p>
        Die App wird auf Servern der Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen,
        in Deutschland betrieben. Mit dem Anbieter besteht ein Vertrag zur Auftragsverarbeitung
        gemäß Art. 28 DSGVO.
      </p>

      <h2>5. Empfänger und Auftragsverarbeiter</h2>
      <p>
        Wir geben personenbezogene Daten nur weiter, soweit dies zur Leistungserbringung
        erforderlich ist oder eine Rechtsgrundlage besteht. Eingesetzte Dienstleister
        (z. B. Hosting) sind vertraglich als Auftragsverarbeiter gebunden. Eine Übermittlung in
        Drittländer findet nicht statt.
      </p>

      <h2>6. Verarbeitung im Auftrag unserer Kundinnen und Kunden</h2>
      <p>
        Soweit im Rahmen der App personenbezogene Daten Dritter (etwa von Kunden oder
        Ansprechpartnern des Mandanten) verarbeitet werden, handelt der jeweilige Mandant als
        Verantwortlicher und die blitzblank GmbH als Auftragsverarbeiterin nach Art. 28 DSGVO.
        Grundlage ist der mit dem Mandanten geschlossene Auftragsverarbeitungsvertrag.
      </p>

      <h2>7. Speicherdauer</h2>
      <p>
        Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke
        erforderlich ist oder gesetzliche Aufbewahrungsfristen es vorschreiben. Kontodaten werden
        nach Beendigung des Vertragsverhältnisses gelöscht, soweit keine Aufbewahrungspflicht
        entgegensteht.
      </p>

      <h2>8. Deine Rechte</h2>
      <p>Dir stehen nach der DSGVO folgende Rechte zu:</p>
      <ul>
        <li>Auskunft über die verarbeiteten Daten (Art. 15 DSGVO)</li>
        <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch gegen Verarbeitungen auf Grundlage berechtigter Interessen (Art. 21 DSGVO)</li>
        <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO), siehe Ziffer 2</li>
      </ul>
      <p>
        Zur Ausübung deiner Rechte genügt eine Nachricht an{' '}
        <a href="mailto:hallo@always-on-stock.de">hallo@always-on-stock.de</a>.
      </p>

      <h2>9. Datensicherheit</h2>
      <p>
        Die Übertragung erfolgt verschlüsselt über TLS. Wir treffen angemessene technische und
        organisatorische Maßnahmen, um deine Daten gegen unbefugten Zugriff, Verlust oder
        Manipulation zu schützen.
      </p>

      <h2>10. Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir passen diese Datenschutzerklärung an, wenn sich die Verarbeitung oder die Rechtslage
        ändert. Es gilt jeweils die hier veröffentlichte, aktuelle Fassung.
      </p>
    </LegalLayout>
  );
}
